var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"20px"}},[_c('div',{staticClass:"top-fluid text-left"},[_c('h4',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(this.models.title))]),_vm._v(" "),_c('div',{staticStyle:{"text-indent":"2em"}},[_vm._v(_vm._s(this.models.detailed))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69eb24e1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/help_clause.vue
// module id = null
// module chunks = 